module.exports = __webpack_public_path__ + "static/media/first.f05b1799.jpeg";